/**
 * Secure JWT Utility functions for user data retrieval via API
 * Note: JWT tokens are now stored in httpOnly cookies for security
 */

import api from '../api/apiClient';

/**
 * Get current user information from server (secure)
 * @returns {object|null} - User information or null if not authenticated
 */
export const getCurrentUser = async () => {
	try {
		const response = await api.get('/api/v1.0/auth/current-user');
		return response.data;
	} catch {
		return null;
	}
};

/**
 * Get client ID from current user (secure)
 * @returns {string|null} - Client ID or null if not available
 */
export const getCurrentClientId = async () => {
	try {
		const user = await getCurrentUser();
		return user?.ClientId || user?.clientId || null;
	} catch (error) {
		return null;
	}
};

/**
 * Logout user by calling server logout endpoint
 * @returns {boolean} - True if logout successful
 */
export const logoutUser = async () => {
	try {
		await api.post('/api/v1.0/auth/logout');
		return true;
	} catch (error) {
		// Still consider it successful to clear client state
		return true;
	}
};

